<template>
    <div id="app">
<!--      头部-->
      <HeaderTitle :username="userName" :toptype="topType"></HeaderTitle>
      <section class="banner_div word">
<!--        中间内容框-->
        <SuccessBox :stitle="sTitle" ></SuccessBox>
        <div class="footer">
          <PageFooter></PageFooter>
        </div>
      </section>
    </div>
</template>

<script>
  import HeaderTitle from "../assembly/HeaderTitle";
  import SuccessBox from "../popBox/SuccessPop";
  import PageFooter from "../assembly/PageFooter";
  
    export default {
        name: "PaySuccess",
      data(){
        return {
          userName:'赵四',
          sTitle:'您已付款成功！',
          toptype:'usermsg', //顶部信息
        }
      },
      components:{
          HeaderTitle,SuccessBox,PageFooter
      }
    }
</script>

<style scoped>
.banner_div{
  padding-top: 28px;
}
  .footer{
    padding-top: 181px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pay/Pay.vue